import * as J from "../../node_modules/.pnpm/three@0.172.0/node_modules/three/build/three.tsl.js";
import { getAspectCorrectedCoordinates as Z } from "../../utilities/uv.js";
import { grain as $ } from "../../helpers/grain.js";
import { distort as oo } from "../../helpers/distort.js";
import { glow as to } from "../../helpers/glow.js";
import { edgeMask as so } from "../../helpers/edgeMask.js";
const ao = {
  name: "Chromatic4",
  collection: "chromatic",
  tags: ["wave", "gradient"],
  props: {
    speed: {
      type: Number,
      default: 1,
      description: "The speed of the wave effect."
    }
  },
  fragmentNode: (m) => {
    const {
      vec3: E,
      vec4: O,
      time: T,
      mix: n,
      sin: d,
      float: o,
      pow: c,
      uv: l,
      color: t
    } = J, f = t("#8e7925"), N = t("#917929"), u = t("#c9caa1"), r = t("#ff832b"), C = t("#988d62"), S = t("#a85e99"), p = 0.5, I = 0.5, R = -0.05, D = -0.1, G = 0.2, A = 0.5, L = 54, g = 0.8, Y = 0.03, b = 0.5, F = 0.5, v = 0.1, w = 0.5, x = 1, U = 0.2, B = 0.1, s = l(), { correctedUV: V } = Z(), _ = oo(s, G, A, L), W = c(f, o(2.2)), h = c(N, o(2.2)), y = c(u, o(2.2)), k = c(r, o(2.2)), H = n(
      W,
      h,
      s.y
    ), P = n(
      k,
      y,
      s.x
    ), K = n(
      H,
      P,
      s.x
    ), a = _.x.sub(0.3), i = _.y.sub(0.5), M = i.mul(a).add(i.mul(a)).negate(), e = o(1).add(
      o(g).mul(
        d(
          M.add(T.mul(m.speed.uniform).mul(0.025)).div(Y)
        )
      )
    ), Q = so({
      inset: p,
      softness: I,
      offsetX: R,
      offsetY: D
    }), X = E(e, e, e).mul(Q).mul(b), z = n(
      S.mul(B),
      C.mul(U),
      s.y.mul(s.x)
    ), j = $(F)(V), q = O(
      z.add(K.mul(X)).sub(j),
      1
    );
    return to(q, r, v, w, x);
  }
};
export {
  ao as componentDefinition,
  ao as default
};
